exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Footer-module__efk__footer__1azMd {\r\n    display: flex;\r\n    flex-wrap: nowrap;\r\n    align-items: center;\r\n    justify-content: space-evenly;\r\n    margin: auto;\r\n    width: 96%;\r\n}\r\n  \r\n.Footer-module__footer__link_github__3GlWv,\r\n.Footer-module__footer__year__3OJaG {\r\n    font-size: 30px;\r\n    text-decoration: none;\r\n    color: #000;\r\n}\r\n  \r\n.Footer-module__footer__logo__-IVDD {\r\n    width: 100%;\r\n}\r\n\r\n.Footer-module__footer__link__PjG5u {\r\n    width: 100px;\r\n    text-decoration: none;\r\n}\r\n\r\n@media (max-width: 799px) {\r\n\r\n    .Footer-module__footer__link_github__3GlWv,\r\n    .Footer-module__footer__year__3OJaG {\r\n      font-size: 20px;\r\n    }\r\n\r\n    .Footer-module__footer__link__PjG5u {\r\n        width: 80px;\r\n    }\r\n  \r\n}", ""]);

// exports
exports.locals = {
	"efk__footer": "Footer-module__efk__footer__1azMd",
	"footer__link_github": "Footer-module__footer__link_github__3GlWv",
	"footer__year": "Footer-module__footer__year__3OJaG",
	"footer__logo": "Footer-module__footer__logo__-IVDD",
	"footer__link": "Footer-module__footer__link__PjG5u"
};